import { EditType, PagesData, TemplateType } from "@store/reducers/init/types"
import { inchesToPixel } from "@utils/data"

export const initialPaperState = {
  showBackgroundImage: false,
  isFloorMap: false,
  attendees: [],
  isTableFinder: false,
  tableDataGlobal: {
    statusColors: {
      none: '#808080',
      checkedin: '#008000',
      checkedout: '#f44336'
    }
  },
  sponsorLogos: [],
  isAttendeeFloorMap: false,
  needConfirmation: false,
  unitType: "inch", //pixels, inch
  selectedTags: [],
  isAddOnBadge: false,
  selectedPageIndex: 0,
  layout: {
    type: "multi",
    pageMargins: { top: 0, bottom: 0, left: 0, right: 0, centerH: true, centerV: true },
    badgeMargins: { right: 0, bottom: 0 },
    gridSizes: {
      custom: null,
      calculated: { rows: 1, columns: 1 },
    },
    paperSize: { width: 1, height: 1 },
  },

  thirdParty: false, // example: avery, dymo , brother
  thirdPartyFormat: {},
  thirdPartyName: "",
  //FormatSettings
  pageSize: { name: '4.0" x 3.0"', height: inchesToPixel(3), width: inchesToPixel(4) },
  pageSizes: {},
  isCustomFormatSizeMode: false,
  formats: {},
  isCustomPageSizeMode: false,
  selectedFormat: {
    id: "2",
    height: 288,
    width: 384,
    name: '4.0" x 3.0"',
    heightInInch: "3",
    widthInInch: "4",
  },
  pageOption: "single",
  seperatePages: false,
  currentDesignId: null,
  enabledModules: [], //'scan', 'quick', 'attendee',fisMirror
  canvasReset: 0, //When we reset canvas we increase this to let the components know that canvas has been reset
  editType: "edit" as EditType,
  templateType: "badge" as TemplateType,
  selectedPage: 0,
  pageData: [
    {
      templateData: { background: "#ffffff", objects: [] },
      pageLabel: "Page 1",
      pageSource: "custom",
      printRotation: false,
      index: 0,
      isLocked: false,
      copyIndex: null
    },
    {
      templateData: { background: "#ffffff", objects: [] },
      pageLabel: "Page 2",
      pageSource: "original",
      printRotation: true,
      index: 1,
      isLocked: false,
      copyIndex: 0
    },
  ] as unknown as PagesData,
  gridUpdateCounter: 0,
  boothColorSetting:{
    soldColor : "#ea0b14b8",
    availableColor : "#7de900b8",
    reserveColor : "#e9df00b8",
  },
  showBoothRegistration: true,
}
